import { render, staticRenderFns } from "./DeletePolicyModal.vue?vue&type=template&id=f92cf79a&scoped=true"
import script from "./DeletePolicyModal.vue?vue&type=script&lang=js"
export * from "./DeletePolicyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92cf79a",
  null
  
)

export default component.exports